import { render, staticRenderFns } from "./salaryBill.vue?vue&type=template&id=063d8a52"
import script from "./salaryBill.vue?vue&type=script&lang=js"
export * from "./salaryBill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports